module.exports = __webpack_public_path__ + "img/HAB_Logo.277c8121.svg";